export default __webpack_public_path__ + "static/media/instagram.c3bcd91b.svg";